import { AcademyIcon, CalenderIcon, HomeIcon, PlusIcon, ReelVideoFillIcon } from '@insta-club/components/icons';
import { Avatar } from '@insta-club/ui';
import { useMemo } from 'react';

interface UseMenuItemsProps {
    hasNoPages: boolean;
    activePageDetail: {
        image?: string;
        page?: string;
    } | null;
    handleHoldStart: () => void;
    handleHoldEnd: () => void;
}

export const useMenuItems = ({ hasNoPages, activePageDetail, handleHoldStart, handleHoldEnd }: UseMenuItemsProps) => {
    return useMemo(
        () => [
            {
                name: 'داشبورد',
                href: '/dashboard',
                icon: <HomeIcon />
            },
            {
                name: 'برنامه من',
                href: '/analysis',
                icon: <CalenderIcon width={24} height={24} className='fill-current' />
            },
            {
                name: 'ایده محتوا',
                href: '/explore',
                icon: <ReelVideoFillIcon />
            },
            {
                name: 'آکادمی',
                href: '/academy',
                icon: <AcademyIcon />
            },
            {
                name: !hasNoPages ? 'اکانت من' : 'افزودن',
                href: !hasNoPages ? '/profile' : '/profile/add-page/intro',
                icon: !hasNoPages ? (
                    <div
                        onMouseDown={handleHoldStart}
                        onMouseUp={handleHoldEnd}
                        onMouseLeave={handleHoldEnd}
                        onTouchStart={handleHoldStart}
                        onTouchEnd={handleHoldEnd}
                    >
                        <Avatar src={activePageDetail?.image ?? ''} alt={activePageDetail?.page ?? ''} size={24} />
                    </div>
                ) : (
                    <div
                        className='bg-primary-50 flex items-center justify-center overflow-hidden rounded-full'
                        style={{ width: 24, height: 24 }}
                    >
                        <span className='text-primary-500 relative top-[1px] !font-sans text-sm font-bold'>
                            <PlusIcon />
                        </span>
                    </div>
                )
            }
        ],
        [handleHoldStart, handleHoldEnd, hasNoPages, activePageDetail]
    );
};

